export default {
  title: 'Votre déménagement',
  preBooking: {
    titleIndividual: 'Choisissez votre déménageur',
  },
  error: 'Vos devis ne sont pas encore disponibles pour le moment.',
  back: 'Retour au comparatif',
  cardFlex: {
    button: 'Plus d\'infos',
    message: '<b>{step}</b>',
  },
  carousel: {
    error: 'Une erreur est survenue lors du chargement de la photo.',
    notFound: 'Aucune photo n\'a été trouvé.',
  },
  warning: {
    title: 'Attention',
    button: 'J\'accepte le reste à charge',
  },
  offers: {
    header: {
      from: 'le {date}',
      fromToShort: '{date1} - {date2}',
      fromToLong: 'du {date1} au {date2}',
      between: 'entre le {date1} et le {date2}',
      formuleDetails: {
        title: 'La {formuleName}, c\'est quoi ?',
        intro: 'Cette formule inclut les prestations réalisées par les déménageurs listées ci-dessous. Voici ce qui est pris en charge et ce qui reste à votre charge.',
        close: 'Fermer',
        help: 'Besoin d\'aide pour choisir ? Contactez-nous au',
        success: {
          subTitle: 'Ce que font les déménageurs',
        },
        danger: {
          subTitle: 'Ce qui reste à votre charge',
        },
      },
    },
    offer: {
      recommend: 'Recommandé par votre conseiller',
      rating: {
        alt: 'Excellence Nextories 2024',
        no: 'Pas encore de note',
      },
      mover: {
        created: 'Entreprise créée en {date}',
        address: '{city} ({postal})',
        more: 'En savoir plus',
        tag: '{name} - {description}',
      },
      rateGuaranteed: 'Tarif garanti',
      count: '({count} notes)',
      rateMoy: 'Moyenne sur les {count} dernières notes',
      insurance: 'Garantie',
      includedServices: 'Services inclus',
      assuranceServices: 'Garantie',
      options: 'Options',
      optionsSelected: 'Options choisies',
      city: 'Ville',
      clientRating: 'Note clients',
      quotationPreparation: 'Devis en préparation',
      validationPreparation: 'Validation en cours',
      openQuotationSigned: 'Voir le devis signé',
      repaymentCeiling: 'Votre plafond',
      openQuotation: 'Voir le devis',
      preBooking: 'Pré-réserver',
      preBookingIndividual: 'Choisir',
      signQuotation: 'Signer Le devis',
      preReservationQuotation: 'Devis pré-réservé',
      choose: 'Choisir',
      choosen: 'Choisi',
      refused: 'Écarté',
      gmPrice: 'Loyer mensuel <b>non inclus</b> de {price} € TTC',
      ratings: {
        contact_quality: 'Contact commercial',
        punctuality: 'Ponctualité',
        materials_quality: 'Matériel utilisé',
        furniture_protection: 'Protection du mobilier',
      },
      contentFailure: '<div class="u-padding-vt-default u-color-grey-blue u-padding-hz-default u-text-align-center u-font-size-default">Ce devis ne peut plus être choisi.<span class="u-padding-top-default u-display-block"><b>Veuillez en choisir un autre.</b></span></div>',
    },
  },
  method: {
    header: 'Voir les critères de comparaison',
    content: `<ul><li>Nextories permet d’obtenir et de comparer jusqu’à six offres de déménageurs professionnels obtenues à la suite d’une analyse impartiale et objective de celles-ci classées en priorité par prix croissant et combinées avec des critères de notation de qualité et d’expertise technique mais aussi de rapidité de réponse, de respect du cahier des charges et de disponibilité parmi 250 prestataires référencés.</li>
<li>En amont, Nextories vérifie la conformité de documents réglementaires en cours de validité des déménageurs tels qu’attestation URSSAF, K-BIS, assurance responsabilité civile professionnelle et licence de transport de marchandises.</li>
<li>Nextories dispose seulement de liens contractuels avec tous ses partenaires déménageurs lesquels se sont engagés à respecter une charte de qualité et de déontologie et à agir en conformité avec la réglementation en vigueur. Nextories est donc juridiquement et financièrement indépendante de ses partenaires déménageurs référencés de leur propre initiative sans contrepartie.</li>
<li>Nextories est rémunéré via un apport d’affaires qui intègre les coûts d’étude technique et de suivi commercial.</li>
<li>Vous êtes destinataire d’un devis et d’une synthèse de chaque offre complète comprenant les informations relatives au prix, au déménageur ainsi que les conditions d’assurances avec les éventuelles options d’usage. Le déménageur ne peut facturer de frais supplémentaires sauf modification express du devis, des prestations ou du cahier des charges. Les offres présentées sont donc complètes et exhaustives sous réserve de modifications ultérieures du fait des options choisies.</li>
<li>Chaque offre est unique et éditée pour une durée d’un mois sous réserve de disponibilité du déménageur aux dates initialement demandées. L’actualisation d’une offre ne peut être effectuée qu’en cas de dépassement de sa durée de validité ou en cas de modification du besoin par l’utilisateur.</li>`,
  },
};
